/** 상점 공유상점 통계 엔티티 */
export default class StatsStoreShareStore {
    /** 아이디 */
    id = 0;
    /** 주문 허브 코드 */
    orderHubCode = '';
    /** 주문 허브 이름 */
    orderHubName = '';
    /** 상점 코드 */
    storeCode = '';
    /** 상점 이름 */
    storeName = '';
    /** 수행 허브 코드 */
    agencyHubCode = '';
    /** 수행 허브 이름 */
    agencyHubName = '';
    /** 건수 */
    count = 0;
    /** 공급가액 */
    supplyCost = 0;
    /** 세액 */
    tax = 0;
    /** 배달대행료합계 */
    totalDeliveryFee = 0;
    constructor(_data = {}) {
        Object.assign(this, _data);
    }
}
